import createReducer from 'data/shared/createReducer';
import { followup as actions } from 'data/followup/constants/action_types';
import reverse from 'lodash/reverse';
import { CREDIT_CARD } from 'data/followup/constants/payment_methods';

const initialState = {
    isFetching: true,
    isDeleting: false,
    isCancelingUpdateRequest: false,
    reference: null,
    result: null,
    acceptQuotation: {
        showForm: false,
        isLoading: false,
        showSuccess: false
    },
    pay: {
        showForm: false,
        showSuccess: false,
        isFetching: true,
        creditCardFields: null,
        method: CREDIT_CARD
    },
    entities: {}
};

const cancelAll = (state, action) => ({
    ...state,
    acceptQuotation: {
        ...initialState.acceptQuotation
    },
    pay: {
        ...initialState.pay
    }
});

const refreshEntities = (state, action) => {
    const reservationId = action.data.result;
    const reservation = action.data.entities.reservations[reservationId];

    return {
        ...state,
        result: reservationId,
        entities: {
            ...action.data.entities,
            reservations: {
                [reservationId]: {
                    ...reservation,
                    history: reverse(reservation.history)
                }
            }
        }
    };
};

const request = (state, action) => ({
    ...state,
    isFetching: true,
    reference: action.reference
});

const receive = (state, action) => ({
    ...refreshEntities(state, action),
    isFetching: false,
    result: action.data.result
});

const sendInstantMessageSuccess = (state, action) => refreshEntities(state, action);

const showAcceptQuotation = (state, action) => ({
    ...state,
    acceptQuotation: {
        ...state.acceptQuotation,
        showForm: true
    }
});

const cancelAcceptQuotation = (state, action) => ({
    ...cancelAll(state, action)
});

const acceptQuotation = (state, action) => ({
    ...state,
    acceptQuotation: {
        ...state.acceptQuotation,
        isLoading: true
    }
});

const acceptQuotationSuccess = (state, action) => ({
    ...refreshEntities(state, action),
    acceptQuotation: {
        ...state.acceptQuotation,
        showForm: false,
        isLoading: false,
        showSuccess: true
    }
});

const acceptQuotationFailure = (state, action) => ({
    ...state,
    acceptQuotation: {
        ...state.acceptQuotation,
        isLoading: false
    }
});

const showPay = (state, action) => ({
    ...state,
    pay: {
        ...state.pay,
        showForm: true
    }
});

const choosePaymentMethod = (state, action) => ({
    ...state,
    pay: {
        ...state.pay,
        method: action.method
    }
});

const requestCreditCardFields = (state, action) => ({
    ...state,
    pay: {
        ...state.pay,
        isFetching: true,
        creditCardFields: null
    }
});

const receiveCreditCardFields = (state, action) => ({
    ...state,
    pay: {
        ...state.pay,
        isFetching: false,
        creditCardFields: action.fields
    }
});

const paymentSuccess = (state, action) => ({
    ...state,
    pay: {
        ...state.pay,
        showForm: false,
        showSuccess: true
    }
});

const paymentFailure = (state, action) => ({
    ...state,
    pay: {
        ...state.pay,
        showForm: false,
        showSuccess: false,
        showError: true
    }
});

const requestDeleteDraft = (state, action) => ({
    ...state,
    isDeleting: true
});

const receiveDeleteDraft = (state, action) => ({
    ...state,
    isDeleting: false
});

const submitUpdateCancellation = (state, action) => ({
    ...state,
    isCancelingUpdateRequest: true
});

const submitUpdateCancellationEnded = (state, action) => ({
    ...state,
    isCancelingUpdateRequest: false
});

export default createReducer(initialState, {
    [actions.REQUEST]: request,
    [actions.RECEIVE]: receive,
    [actions.SEND_INSTANT_MESSAGE_SUCCESS]: sendInstantMessageSuccess,
    [actions.SHOW_ACCEPT_QUOTATION]: showAcceptQuotation,
    [actions.CANCEL_ACCEPT_QUOTATION]: cancelAcceptQuotation,
    [actions.ACCEPT_QUOTATION]: acceptQuotation,
    [actions.ACCEPT_QUOTATION_SUCCESS]: acceptQuotationSuccess,
    [actions.ACCEPT_QUOTATION_FAILURE]: acceptQuotationFailure,
    [actions.SHOW_PAY]: showPay,
    [actions.CHOOSE_PAYMENT_METHOD]: choosePaymentMethod,
    [actions.REQUEST_CREDIT_CARD_FIELDS]: requestCreditCardFields,
    [actions.RECEIVE_CREDIT_CARD_FIELDS]: receiveCreditCardFields,
    [actions.PAYMENT_SUCCESS]: paymentSuccess,
    [actions.PAYMENT_FAILURE]: paymentFailure,
    [actions.CANCEL_ALL]: cancelAll,
    [actions.DELETE_DRAFT]: requestDeleteDraft,
    [actions.DELETE_DRAFT_SUCCESS]: receiveDeleteDraft,
    [actions.DELETE_DRAFT_FAILURE]: receiveDeleteDraft,
    [actions.SUBMIT_UPDATE_CANCELLATION]: submitUpdateCancellation,
    [actions.SUBMIT_UPDATE_CANCELLATION_SUCCESS]: submitUpdateCancellationEnded,
    [actions.SUBMIT_UPDATE_CANCELLATION_FAILURE]: submitUpdateCancellationEnded,
});
